"use client"

import { useState } from "react";
import { ProductReviewList } from "./components/ProductReviewList"
import { ProductReviewScore } from "./components/ProductReviewScore";
import { useTranslate } from "@tolgee/react";
import LazyLoadWrapper from "@/components/LazyLoadWrapper";

export const ProductReview = ({
    product_id,
    locale,
}: {
    product_id: string,
    locale: string
}) => {
    const { t } = useTranslate()

    const [summary, setSummary] = useState<{ rating_avg: number, review_count: number }>()

    return (
        <div className="bg-white border border-black/10 rounded-md overflow-hidden">
            <div className="border-b border-black/10 px-6 pt-3 pb-[13px]">
                <h3 className="text-[14px] font-medium text-[#0a0a0a] tracking-[-0.15px]">{t("product_details.product_reviews_heading")}</h3>
            </div>
            <div className="flex flex-col lg:flex-row items-stretch">
                <div className="shrink-0 border-b lg:border-b-0 lg:border-r border-black/10 lg:w-[220px]">
                    <ProductReviewScore rate={summary?.rating_avg || 0} reviewCount={summary?.review_count || 0} />
                </div>
                <div className="flex-1 min-w-0">
                    <LazyLoadWrapper>
                        <ProductReviewList
                            product_id={product_id}
                            locale={locale}
                            handleReviewsSummary={setSummary}
                        />
                    </LazyLoadWrapper>
                </div>
            </div>
        </div>
    )
}
